import * as React from 'react';

// #region Component Props

interface IProps {
    id          : string;
    text        : string;
    onBtnClick  : any;
    classes?    : string;
    disabled?   : boolean;
    icon        : string;
}

// #endregion

const ClearButton : React.SFC<IProps> = (props) => {

    const { id, icon, text, onBtnClick, classes, disabled } = props;
    const classList = 'btn-clear ' + (classes ? classes : '');

    return <button 
                id={id}
                type="button"
                disabled={ disabled }
                className={ classList } 
                onClick={ onBtnClick }>
                    {
                        icon && icon.length > 0
                            ? <i className={'la ' + icon } />
                            : null
                    }                
                    { text }
            </button>;
};

ClearButton.defaultProps = {
    classes: '',
    disabled: false
};

export { ClearButton };
